import { Button, Modal } from 'antd'
import { Html5Qrcode } from 'html5-qrcode'
import { Camera } from 'lucide-react'
import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

const ScannerInner = ({ onScan, onClose }) => {
	const scannerRef = useRef(null)
	const onScanRef = useRef(onScan)
	const onCloseRef = useRef(onClose)

	// Keep refs up to date with the latest props
	useEffect(() => {
		onScanRef.current = onScan
		onCloseRef.current = onClose
	}, [onScan, onClose])

	useEffect(() => {
		const html5QrCode = new Html5Qrcode('camera-reader')
		scannerRef.current = html5QrCode

		const startScanner = async () => {
			try {
				const devices = await Html5Qrcode.getCameras()
				if (devices && devices.length > 0) {
					await html5QrCode.start(
						{ facingMode: 'environment' },
						{
							fps: 10,
							qrbox: { width: 250, height: 250 },
						},
						(decodedText) => {
							if (onScanRef.current) onScanRef.current(decodedText)
							if (onCloseRef.current) onCloseRef.current()
						},
						() => {
							// Global error handler - ignore errors
						},
					)
				}
			} catch (err) {
				console.error('Unable to start scanning', err)
			}
		}

		startScanner()

		return () => {
			if (scannerRef.current) {
				const stopScanner = async () => {
					try {
						if (scannerRef.current.isScanning) {
							await scannerRef.current.stop()
						}
					} catch (err) {
						// Error during stop is common if component unmounts quickly
					}
				}
				stopScanner()
			}
		}
	}, []) // Empty dependency array means this runs only once on mount

	return (
		<div className="relative bg-gray-100 rounded-lg overflow-hidden border-2 border-dashed border-gray-300">
			<div
				id="camera-reader"
				className="w-full"
				style={{ minHeight: '300px' }}
			></div>
			<div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 border-2 border-red-500 rounded-lg pointer-events-none opacity-50"></div>
		</div>
	)
}

const CameraScanner = ({ visible, onScan, onClose }) => {
	const { t } = useTranslation()

	return (
		<Modal
			open={visible}
			onCancel={onClose}
			footer={null}
			title={
				<div className="flex items-center gap-2">
					<Camera size={20} />
					<span>{t('scanBarcode')}</span>
				</div>
			}
			destroyOnClose
			width={500}
		>
			{visible && <ScannerInner onScan={onScan} onClose={onClose} />}
			{/* {visible && <ScannerInner onScan={onScan} onClose={onClose} />} */}
			<div className="mt-4 flex justify-center">
				<Button onClick={onClose} type="primary" danger>
					{t('cancel')}
				</Button>
			</div>
		</Modal>
	)
}

export default CameraScanner
